export const phrases = {
  heading_settings_sort: "فرز قائمة الموظفين",
  body_settings_sort: "فرز قائمة الموظفين حسب الاسم الأول أو الأخير.",
  since_o_clock: "منذ {time} ساعة",
  old_data_warning_my_area: "لم نتمكن من تحميل أي معلومات جديدة. تأكد من اتصالك بالإنترنت.",
  no_data_warning_my_area: "تأكد من اتصالك بالإنترنت وحاول مرة أخرى.",
  no_data_available_my_area: "لا يمكن تحميل أي بيانات",
  last_update_data: "آخر تحديث",
  something_went_wrong_absences: "حدث خطأ ما. يرجى إعادة المحاولة في وقت لاحق.",
  something_went_wrong_with_the_pin_entry: "حدث خطأ ما في إدخال رقم التعريف الشخصي ...",
  pin_must_be_four_digits: "يجب أن يتكون رقم التعريف الشخصي من أربعة أرقام بالضبط.",
  pins_do_not_match: "أرقام التعريف الشخصية التي تم إدخالها غير متطابقة.",
  pin_is_not_numerical: "يمكن أن يتكون رقم التعريف الشخصي من أرقام فقط.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "الخروج",
  finish_break: "إنهاء استراحة",
  finish_loading_time: "إيقاف وقت الشحن",
  finish_driving_time: "نهاية وقت القيادة",
  finish_business_trip: "إنهاء رحلة عمل",
  finish_project_as_task: "نهاية المشروع",
  finish_special_one: "خروج سوندر1",
  finish_special_two: "قم بإنهاء Sonder2",
  you_clockout: "أنت تراقب نفسك",
  sentence_work_time: "أنت تعمل الآن. | أنت تعمل الآن.",
  sentence_break: "أنت تأخذ استراحة. | أنت تأخذ استراحة.",
  sentence_loading_time: "أنت تقوم حاليا بتسجيل وقت التحميل. عجل! | أنت تقوم حاليا بتسجيل وقت التحميل. عجل!",
  sentence_business_trip: "رحلة عمل تسجيل الدخول. استمتع!",
  sentence_driving_time: "أنت فقط تحجز وقت السفر. اربطوا أحزمة الأمان وانطلقوا! | أنت فقط تحجز وقت السفر. اربط أحزمة الأمان وانطلق!",
  sentence_special_one: "أنت تحجز حاليا Sonder1. | أنت تحجز حاليا Sonder1.",
  sentence_special_two: "أنت تحجز حاليا Sonder2. | أنت تحجز حاليا Sonder2.",
  sentence_custom_time: "أنت تحجز | أنت فقط تحجز",
  you_are_booked_in_activity: "أنت ختم {activity}! | أنت ختم {activity}!",
  substitute_warning: "{ days } يجب تسمية نائب للنائب في حالات الغياب لأيام أو أكثر.",
  substituted_by: "ممثلة من قبل",
  name_clocked_in: "{name} ختمها",
  /************************************/
  //Signature stuff:

  signature: "توقيع",
  please_sign: "الرجاء التوقيع",
  signature_with_date: "توقيع {date}",
  signature_with_date_with_name: "توقيع {date} من {name}",
  signature_with_date_with_location: "توقيع {date} في {location}",
  signature_with_date_with_name_with_location: "توقيع {date} من {name} في {location}",
  signature_with_name: "توقيع {name}",
  signature_with_name_with_location: "توقيع {name} في {location}",
  signature_with_location: "التوقيع في {location}",
  /*************************************/

  accept_terms_and_conditions: "من خلال إرسال النموذج ، فإنك تقبل {agb} ولدينا {datenschutzerklaerung}.",
  what_is_your_name: "ما اسمك؟",
  your_email: "عنوان بريدك الإلكتروني",
  what_is_your_company_name: "ما هو اسم شركتك؟",
  what_do_you_want_to_do_with_clockin: "Was möchtest du mit clockin machen?",
  almost_finished: "أوشكت على الانتهاء",
  test_clockin_for_amount_period: "تيست كلوكين {amountOfDaysTestPeriod} أيام مجانا!",
  code_needed_to_connect: "استخدم التعليمات البرمجية الخاصة بك",
  you_have_no_company_code: "ليس لديك رمز؟ تواصل مع جهة الاتصال في شركتك.",
  connect_your_device: "قم بتوصيل جهازك!",
  please_type_in_device_id: "يرجى إدخال معرف الجهاز ، والذي يمكنك العثور عليه ضمن الأجهزة المحمولة على موقعنا.",
  new_at_clockin: "هل أنت جديد على مدار الساعة؟",
  pin_repeat: "كرر رقم التعريف الشخصي",
  configure_your_pin: "تعيين رقم التعريف الشخصي المكون من 4 أرقام",
  configure_your_pin_text: "ستحتاج إلى رقم التعريف الشخصي للوصول إلى منطقتك الشخصية في محطة الجهاز اللوحي.",
  congratulations: "مبروك!",
  start_now: "هيا بنا نبدأ",
  device_name_info: "يمكنك تغيير اسم الجهاز الخاص بجهازك المحمول لتتبع أجهزة متعددة. مثال: \"الهاتف الذكي MaxMustermann\". يمكن أيضا تغيير الاسم في وقت لاحق.",
  select_project: "اختر مشروعا",
  select_time: "اختر الوقت",
  create_new_account: "إنشاء حساب جديد",
  join_my_company: "انضم إلى شركتي",
  join_clockin_with_qr: "انضم باستخدام رمز الاستجابة السريعة",
  change_project: "تغيير المشروع",
  my_messages: "رسائلي",
  my_documents: "المستندات الخاصة بي",
  my_data_and_passwords: "بياناتي وكلمات المرور الخاصة بي",
  my_account_data: "بياناتي",
  change_my_password: "تغيير كلمة المرور",
  forgot_password: "لا أعرف كلمة المرور الخاصة بي.",
  open_camera: "افتح الكاميرا",
  scan_now: "امسح الآن",
  sync_now: "مزامنة الآن",
  clear_logs: "مسح السجلات",
  saveAndGoBack: "حفظ وإرجاع",
  full_day: "يوم كامل",
  activate_scanner: "تم تنشيط الماسح الضوئي",
  scanner_is_inactive: "الماسح الضوئي غير نشط",
  change_project_by_scan_qr: "امسح رمز الاستجابة السريعة ضوئيا من المشروع الذي تريد التبديل إليه.",
  scan_device_by_qr: "امسح رمز الاستجابة السريعة ضوئيا من الجهاز الذي تريد استخدامه.",
  no_access_to_camera_please_connect_device_manually: "لسوء الحظ ، لم يكن من الممكن الوصول إلى الكاميرا ، يرجى إدخال رمز الجهاز يدويا.",
  no_access_to_camera_please_clockin_manually: "لسوء الحظ ، لم يكن من الممكن الوصول إلى الكاميرا ، يرجى تسجيل الدخول يدويا.",
  qr_code_login: "تسجيل رمز الاستجابة السريعة",
  scan_to_login: "امسح رمز الاستجابة السريعة الخاص بك لتسجيل الدخول.",
  checklist_was_saved: "تم حفظ قائمة التحقق",
  question_save_changes_short: "حفظ التغييرات؟",
  question_save_changes: "هل تريد حفظ التغييرات؟",
  question_delete_checklist_short: "حذف قائمة التحقق؟",
  question_delete_checklist: "هل أنت متأكد من أنك تريد حذف قائمة التحقق؟",
  checklist_is_sending: "سيتم إرسال قائمة مرجعية",
  checklist_sent_successfully: "تم إرسال قائمة التحقق بنجاح 🎉",
  checklist_could_not_be_sent: "تعذر إرسال قائمة التحقق ، يرجى المحاولة مرة أخرى لاحقا.",
  checklist_transmission_problems_in_the_past: "في الماضي ، كانت هناك مشكلات في النقل مع بعض الملفات.",
  checklist_send_with_potential_data_loss: "هل ترغب في محاولة إرسال قائمة التحقق بدون هذه الملفات؟",
  documentation_is_sending: "يتم إرسال وثائق المشروع",
  documentation_sent_successfully: "تم إرسال 🎉 وثائق المشروع بنجاح",
  confirm_documentation_dismissal: "هل أنت متأكد من أنك تريد تجاهل الوثائق؟",
  discard_unsaved_changes: "هل تريد التخلص من تغييراتك؟",
  documentation_will_be_sent_when_online: "سيتم إرسال الوثائق بمجرد معاودة الاتصال بالإنترنت.",
  confirmation_is_sending: "يتم إرسال تأكيد المشروع",
  ask_for_geo_permission: "هذا التطبيق يحتاج إلى موقعك ، " + "لكن لا يوجد إذن للقيام بذلك.\n\n" + "هل تريد فتح الإعدادات؟",
  all_projects: "جميع المشاريع",
  half_day: "نصف يوم",
  start_end: "حسب الوقت",
  my_area: "منطقتي",
  my_area_video_teaser_clockin_explained_by_frederik: "الساعي يشرحه فريدي",
  add_time: "قضاء بعض الوقت",
  show_times_in_confirmation: "أوقات العرض في التأكيد",
  change_time: "تغيير الوقت",
  finish_project: "استكمال المشروع",
  finish_project_date: "أكمل موعدا",
  unfinish_project: "إعادة فتح المشروع",
  unfinish_project_date: "إعادة فتح موعد",
  absence_overview: "إدارة حالات الغياب",
  edit_absence: "تحرير الغياب",
  edited_absence: "تحرير الغياب",
  created_absence: "تم إنشاء طلب الإجازة بنجاح",
  creating_absence: "سيتم الآن إنشاء طلب الغياب الخاص بك",
  error_creating_absence: "خطأ عند إنشاء طلب الإجازة",
  create_absence: "خلق غياب",
  deleted_absence: "سحب طلب الغياب",
  new_request: "تطبيق جديد",
  your_requests: "طلباتك",
  planned_days: "الأيام المجدولة",
  planned_hours: "الساعات المجدولة",
  used_days: "الأيام المستهلكة",
  used_hours: "الساعات التي تقضيها",
  free_days: "أيام العطلة",
  free_hours: "ساعات الإجازة",
  open_days: "أيام مفتوحة",
  open_hours: "ساعات العمل",
  withdraw_request: "سحب الطلب",
  change_request: "تعديل التطبيق",
  request_was_approved: "تمت الموافقة على طلبك",
  request_is_pending: "لم تتم الموافقة على طلبك بعد",
  request_was_rejected: "تم رفض طلبك",
  add_attachment: "إضافة مرفق",
  message_optional: "الرسالة (اختياري)",
  filed_on: "تم الإرسال بتاريخ",
  this_year: "هذا العام",
  search_sub_projects: "ما هو المشروع الفرعي الذي ترغب في العمل عليه؟",
  error_occurred: "حدث خطأ، حاول مرة أخرى لاحقا.",
  re_record: "هل أحذف وأعيد تسجيل هذا الفيديو؟",
  delete_video: "حذف التسجيل؟",
  no_results_found: "لم يتم العثور على نتائج",
  record_again: "اعاده المحاوله",
  request_valid_email: "الرجاء إدخال عنوان بريد إلكتروني صالح.",
  request_valid_company_name: "الرجاء إدخال اسم شركة صحيح.",
  request_valid_first_name: "الرجاء إدخال الاسم الأول الصحيح.",
  request_valid_last_name: "الرجاء إدخال اسم عائلة صالح.",
  total_duration_today: "إجمالي الوقت اليوم",
  show_daily_protocol: "عرض السجل اليومي",
  change_profile_pic: "تغيير صورة الملف الشخصي",
  logout_account: "قطع الاتصال بالحساب",
  you_are_working: "أنت تعمل الآن!",
  you_are_taking_a_break: "أنت تأخذ استراحة!",
  activity_edited: "تم تحرير النشاط",
  activity_edited_undo: "تم التراجع عن التحرير بنجاح",
  activity_edited_missing_project: "لا يزال المشروع مفقوداً!",
  activity_deleted: "تم حذف النشاط",
  activity_deleted_undo: "تم استرداد النشاط المحذوف",
  activity_created: "تم إنشاء نشاط جديد",
  activity_created_undo: "تم سحب النشاط الذي تم إنشاؤه حديثا",
  correct_working_hours: "تصحيح ساعات العمل",
  your_changes_are_being_saved: "سيتم الآن حفظ التغييرات التي أجريتها.",
  manage_working_hours: "إدارة ساعات العمل",
  delete_activity: "حذف النشاط",
  start_navigation: "ابدأ الملاحة",
  no_valid_email: "عنوان البريد الإلكتروني الذي أدخلته غير صالح.",
  delete_checklist: "حذف قائمة الاختيار",
  active_checklists: "قوائم المراجعة النشطة",
  scan_qr_code: "امسح رمز الاستجابة السريعة ضوئيا",
  switch_to_office_center: "التبديل إلى مركز المكتب",
  confirm_project_completion_short: "استكمال المشروع",
  confirm_project_date_completion_short: "أكمل موعدا",
  project_completed: "اكتمل المشروع!",
  project_date_completed: "اكتمل الموعد!",
  confirm_project_uncompletion_short: "إعادة فتح المشروع",
  confirm_project_date_uncompletion_short: "إعادة فتح موعد",
  project_uncompleted: "تم تفعيل المشروع",
  project_date_uncompleted: "تم تفعيل الموعد",
  choose_project: "اختر مشروعا",
  choose_sub_project: "حدد المشروع الفرعي",
  choose_site: "اختر الموقع",
  active_projects: "مشاريع نشطة",
  completed_term: "اكمال",
  completed_projects: "المشاريع المنجزة",
  end_of_work: "أتمنى لك أمسية سعيدة",
  correct_time: "الوقت الصحيح",
  you_stamp_x: "أنت ختم",
  enter_pin: "الرجاء إدخال الرقم السري الخاص بك",
  wrong_pin: "إدخال رقم التعريف الشخصي غير صحيح",
  pin_change_required: "تمت مطالبتك بتغيير رقم التعريف الشخصي الخاص بك",
  enter_new_pin: "أدخل رقم تعريف شخصي جديد",
  approve_pin: "تأكيد رقم التعريف الشخصي",
  no_projects_scheduled: "من أجل {day} لا يتم تخزين أي مشاريع.",
  you_clock_in_project: "من الآن فصاعدا ، سوف تسجل وقت عمل المشروع.",
  project_scan_error: "هذا الرمز غير صالح لأي مشروع.",
  show_more_days: "عرض المزيد من الأيام",
  show_more_times: "عرض المزيد من الأوقات",
  only_show_today: "عرض اليوم فقط",
  todays_total_time: "إجمالي الوقت اليوم",
  everything_synced: "بياناتك محدثة!",
  upload_in_progress: "يتم تحميل البيانات...",
  who_are_you: "من أنت؟؟",
  is_uploading_to_server: "يتم حاليا دفع التغييرات الخاصة بك إلى مركز المكتب.",
  offline_and_data_is_stored_locally: "سيتم نقل تغييراتك قريبا إلى مركز المكتب. ",
  show_more: "التعرف على المزيد",
  activity_edited_wrong_date: "لقد أدخلت تاريخا غير صحيح.",
  confirm_logout: "هل أنت متأكد من رغبتك في إلغاء الاشتراك؟",
  confirm_clockout: "هل أنت متأكد من أنك تريد الخروج لهذا اليوم؟",
  gps_is_active: "يتم إرسال بيانات GPS",
  location_tracking_is_active: "لتمكين تتبع GPS.",
  app_settings: "إعدادات التطبيق",
  clock_reminder: "الطابع - تذكير",
  mon_to_fri: "المعتاد: من الاثنين إلى الجمعة",
  logout: "قطع الاتصال بالحساب",
  refresh: "تحديث",
  prompt_language_settings: "قم بتعيين لغة التطبيق هنا.",
  prompt_clock_reminder: "تذكير عبر إشعار فوري ليتناسب مع عملك اليومي.",
  register_company: "تسجيل شركة",
  use_code: "استخدم الكود",
  our_customers: "عملاؤنا",
  free_test_now: "جربه الآن مجانا",
  tier_attendance: "أنا فقط أسجل ساعات العمل وفترات الراحة.",
  tier_documentation: "أود أيضا حجز ساعات العمل في المشاريع التي أديرها في الساعة.",
  your_tier: "الحزمة الخاصة بك",
  all_clockin_functions: "جميع وظائف الساعة",
  checklists_formulars: "قوائم المراجعة والوظائف",
  projectfile_incl_chat: "ملفات المشروع الرقمية (بما في ذلك الدردشة)",
  photo_sketch_note: "وظيفة الصورة والرسم والملاحظة",
  digital_signature: "التوقيعات الرقمية",
  datev_connection: "اتصال DATEV",
  calendar_absences: "إدارة التقويمات والغياب",
  individual_design: "البصريات الفردية",
  attendance_time_tracking: "تسجيل الوقت الثابت عبر طرف الكمبيوتر اللوحي",
  mobile_time_tracking: "تتبع وقت الهاتف المحمول عبر تطبيق الهاتف الذكي",
  browser_time_tracking: "تتبع وقت المتصفح على جهاز الكمبيوتر للمكتب المنزلي",
  help_use_code: "الرجاء إدخال الرمز الذي يمكن العثور عليه في مركز المكتب ضمن الجوال / الموظفين.",
  wrong_code: "رمز غير صحيح",
  wrong_code_text: "الرمز غير صالح. يرجى المحاولة مرة أخرى باستخدام رمز صالح",
  wrong_code_text_short: "الرمز غير صالح",
  clockin_logo: "شعار كلوكين",
  invalid_qr_code: "رمز الاستجابة السريعة غير صالح",
  invalid_qr_code_text: "رمز الاستجابة السريعة الممسوح ضوئيا غير صالح. يرجى مسح رمز الساعة الصالح.",
  code_already_connected: "يمكنك استخدام هذا الرمز لتوصيل جهازك. لكنك متصل بالفعل.",
  wrong_credentials: "بيانات الوصول غير صحيحة",
  wrong_credentials_text: "تعذر العثور على تركيبة البريد الإلكتروني وكلمة المرور التي أدخلتها. يرجى التحقق من دخولك والمحاولة مرة أخرى.",
  new_pin: "أدخل رقم تعريف شخصي جديد",
  choose_next_action: "اختر الإجراء التالي",
  name_of_software_package: "اسم حزمة البرامج",
  select_teamleader: "من يوجه اللكمات للفريق؟",
  select_teamleader_description: "لمتابعة أنشطة الختم ، يرجى تحديد شخص لتولي الجهاز الآن.",
  clocked_in_on_this_device: "مختومة على هذا الجهاز",
  not_clocked_in_on_this_device: "لم يتم تسجيل الدخول على هذا الجهاز",
  select_new_teamleader: "من يجب أن يختم للفريق الآن؟",
  switch_teamleader: "تسليم الجهاز",
  just_me: "فقط أخرجني",
  select_the_new_teamleader: "تحديد قائد الفريق الجديد",
  back_to_selection: "العودة إلى التحديد",
  manage_team: "إدارة فريقك",
  total_time_team: "إجمالي وقت الفريق",
  count_members_clocked_in: "{clockedin}/{members} أعضاء الفريق مختومون",
  whole_team: "الفريق بأكمله",
  teammembers_still_clockedin: "اختر ما إذا كنت تريد تسجيل نفسك فقط أو كل فرد في الفريق؟",
  clockout_all: "ساعة الكل",
  select_employee: "أولا، حدد مستخدما",
  something_went_wrong: "حدث خطأ ما ، يرجى إعادة المحاولة لاحقا.",
  new_pin_successfully_changed: "تم تغيير رقم التعريف الشخصي بنجاح",
  enter_pin_before_clockin_prompt: "أولا ، أدخل رقم التعريف الشخصي الخاص بك بشكل فردي لتسجيل الدخول.",
  enter_pin_before_clockout_prompt: "أولا ، أدخل رقم التعريف الشخصي الخاص بك بشكل فردي لتسجيل الخروج.",
  delete_activity_alert_title: "حذف النشاط",
  delete_activity_alert_msg: "هل أنت متأكد من رغبتك في حذف النشاط؟",
  delete_absence_message: "هل أنت متأكد من رغبتك في سحب الطلب؟",
  delete_absence_title: "سحب الطلب",
  are_you_sure: "هل أنت متأكد؟",
  request_password: "طلب كلمة مرور جديدة",
  password_requested: "تم إرسال رابط لكلمة مرور جديدة إلى عنوان بريدك الإلكتروني",
  no_email_retrieved: "لم تتلق بريدا إلكترونيا؟ يرجى التحقق من مجلد الرسائل غير المرغوب فيها أو المحاولة مرة أخرى.",
  name_of_customer: "اسم العميل",
  missing_permissions_homepage_text: "ليس لديك إذن لتبديل المهام على هذا الجهاز. يرجى الاتصال بالمسؤول للحصول على حق الوصول.",
  no_permission_warning_my_area: "ليس لديك إذن للوصول إلى هذه المنطقة. يرجى الاتصال بالمسؤول للحصول على حق الوصول.",
  employee_clocked_in: "{name} معلن!",
  employee_clocked_out: "{name} تسجيل!",
  no_employee_to_qr_code_warning: "لا يمكن العثور على موظف لرمز الاستجابة السريعة هذا.",
  no_employees_registered_heading: "لم يتم تعيين أي موظفين لهذا الجهاز حتى الآن.",
  no_employees_registered_body: "في Office Center في إعدادات الجهاز المحمول ، يمكنك تعيين موظفين ، يمكنهم بعد ذلك تسجيل أوقاتهم على هذا الجهاز.",
  no_employee_found: "لسوء الحظ ، لا يمكن العثور على أحد بهذا الاسم.",
  no_employee_assigned: "لم يتم تعيين أي موظف",
  you_need_help: "هل تحتاج إلى مساعدة؟",
  here_you_can_get_help_to_register_employees_for_device: "ستجد هنا جميع المعلومات حول كيفية تعيين الموظفين إلى جهاز.",
  show_time: "قضاء بعض الوقت",
  export_timesheet: "تصدير الجداول الزمنية",
  select_month: "اختر الشهر",
  internet_connection_required: "يلزم الاتصال بالإنترنت لهذا الغرض.",
  select_an_activity_to_clockin_your_team: "اختر نشاطاً لختمه في فريقك.",
  confirm_uploading_sqlite_for_debugging: "هل أنت متأكد من أنك تريد تحميل البيانات في التطبيق لدعم Clockin؟",
  no_tasks_available: "لا توجد مهام متاحة",
  click_to_add_tasks: "انقر لإضافة المهام",
  scan_nfc_tag: "يرجى رفع بطاقتك للقارئ.",
  link_nfc_tag: "رابط علامة NFC",
  select_employee_for_nfc_tag: "يرجى تحديد موظف لربط علامة NFC هذه:",
  nfc_tag_linked_successfully: "علامة NFC بنجاح مع {name} مرتبط.",
  nfc_linking_failed: "تعذر ربط علامة NFC. يرجى المحاولة مرة أخرى.",
  nfc_not_enabled: "NFC غير مدعوم من قبل هذا الجهاز أو يتم تعطيله.",
  nfc_initialization_failed: "لسوء الحظ ، حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  nfc_scan_failed: "لسوء الحظ ، حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  nfc_no_tag_found: "لم يتم العثور على علامة NFC.",
  nfc_tag_already_linked_to: "علامة NFC هذه متاحة بالفعل مع {name} مرتبط.",
  nfc_scan_active: "مسح NFC نشط",
  nfc_linking_enabled: "يمكن الآن ربط علامات NFC. يرجى الاحتفاظ بعلامة NFC ليتم ربطها بقارئ NFC الآن.",
  nfc_all_employees_linked: "تم بالفعل ربط جميع الموظفين المعينين لهذا الجهاز.",
  no_employee_to_nfc_warning: "لا يمكن العثور على أي موظف لعلامة NFC هذه.",
  select_employee_to_link_nfc: "بمن يجب ربط علامة NFC؟",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "مرحبا بك في Clockin",
        clocking_time: "أوقات الحلبات",
        push_notifications: "لا تنس شيئا"
      },
      text: {
        clocking_time: "الساعد هو نقطة انطلاقك لكل نشاط. أنت تعتني بعملك، التطبيق يقوم بالتوثيق.",
        push_notifications: "الآن شغل الإشعارات. تذكرك Clockin إذا نسيت طابعا وتتأكد من أنك تحصل على كل شيء مهم فورا."
      },
      button: {
        lets_go: "ابدأ الآن"
      }
    },
    my_area: {
      heading: {
        my_area: "منطقتي",
        absences: "الغياب والطلبات",
        settings: "الإعدادات الشخصية"
      },
      text: {
        my_area: "المكان المركزي حيث يمكنك مراقبة ساعات العمل والعمل الإضافي على الفور. من هنا ، يمكنك إدارة ساعات عملك ، وعرض سجلك اليومي ، وإرسال الطلبات ، وعرض أوقاتك.",
        absences: "إدارة طلبات الإجازات والأيام المرضية والغياب الأخرى. تتبع دائما حالة طلباتك وأرسل طلبات جديدة بسهولة وسرعة ببضع نقرات فقط.",
        settings: "إرسال رسائل في الشركة أو تغيير إعداداتك الشخصية وإذا كنت ترغب في تغيير كلمة المرور الخاصة بك ، يمكنك القيام بذلك هنا!"
      },
      button: {
        lets_go: "ابدأ"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "لأن وقتك مهم",
        clock_in: "الختم في",
        switch_task: "ريستامب",
        clock_out: "الخروج",
        thats_it: "هذا هو!"
      },
      text: {
        your_time_matters: "مع Clockin ، نساعدك على التركيز على الأساسيات. تتبع وقت عملك بسهولة بنقرة واحدة فقط.",
        clock_in: "بنقرة واحدة يتم تسجيلك مباشرة. يحفظ Clockin بياناتك تلقائيا ويمكنك مراقبة كل شيء في جميع الأوقات.",
        switch_task: "هل لديك مشروع آخر ، هل تأخذ استراحة أم ستذهب إلى موعدك التالي؟ فقط ختم نفسك على نشاطك الجديد. يتم تسجيل الباقي تلقائيا.",
        clock_out: "وبنقرة واحدة ، يتم تسجيل خروجك.",
        thats_it: "لقد قمت بذلك وأنت على استعداد لتتبع ساعات عملك. إذا كنت بحاجة إلى مساعدة ، فقط اتصل بنا. في clockin ، كل شيء سهل - بما في ذلك التواصل معنا."
      },
      button: {
        your_time_matters: "أرني كيف يتم ذلك",
        thats_it: "ابدأ الآن"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "لأن وقتك مهم",
        clock_in: "الختم في",
        clock_in_team: "الساعة في فريقك",
        switch_task: "ريستامب",
        change_teamleader: "تسليم الجهاز",
        clock_out: "الخروج",
        thats_it: "هذا هو!"
      },
      text: {
        your_time_matters: "مع Clockin ، نساعدك على التركيز على الأساسيات. تتبع وقت عمل فريقك بسهولة بنقرة واحدة فقط.",
        clock_in: "حدد شخصا لكمة للفريق وبنقرة واحدة يتم تسجيلك. يحفظ Clockin بياناتك تلقائيا ويمكنك مراقبة كل شيء في جميع الأوقات.",
        clock_in_team: "ختم فريقك بسهولة. لا يهم إذا كان جميع الأعضاء في نفس الوقت أو أعضاء فرديين فقط.",
        switch_task: "هل لديك مشروع آخر ، هل تأخذ استراحة أم ستذهب إلى موعدك التالي؟ فقط ختم على نشاطك الجديد. يتم تسجيل الباقي تلقائيا.",
        change_teamleader: "هل تسميها يوما ، أو تضطر إلى المغادرة أم أنك لم تعد تسجل الدخول للفريق؟ ما عليك سوى تسليم الجهاز في التطبيق وسيسير كل شيء في طريقه الطبيعي.",
        clock_out: "وبنقرة واحدة ، يتم تسجيل خروجك أنت وفريقك. بالطبع ، يمكنك أيضا تسجيل الأعضاء الفرديين في أي وقت.",
        thats_it: "لقد قمت بذلك وأنت جاهز لتتبع وقت العمل لفريقك. إذا كنت بحاجة إلى مساعدة ، فقط اتصل بنا. في clockin ، كل شيء سهل - بما في ذلك التواصل معنا."
      },
      button: {
        your_time_matters: "أرني كيف يتم ذلك",
        thats_it: "ابدأ الآن"
      }
    },
    my_area: {
      heading: {
        welcome: "مرحبا بك في مساحتك",
        my_area: "منطقتي",
        create_time: "قضاء بعض الوقت",
        change_time: "الوقت الصحيح",
        absences: "الغياب والطلبات",
        settings: "الإعدادات الشخصية",
        thats_it: "هذا هو!"
      },
      text: {
        welcome: "اكتشف المزيد من الطرق لإدارة وقت عملك بكفاءة وسهولة. دعونا نلقي نظرة على منطقتك.",
        my_area: "المكان المركزي حيث يمكنك مراقبة ساعات العمل والعمل الإضافي على الفور. من هنا ، يمكنك إدارة ساعات عملك ، وعرض سجلك اليومي ، وإرسال الطلبات ، وعرض أوقاتك.",
        create_time: "هل نسيت تسجيل وقت أو ترغب في إضافة أوقات لاحقا؟ لا توجد مشكلة! أضف الأوقات المفقودة وفواصل السجلات وحافظ على تحديث حساب الوقت الخاص بك.",
        change_time: "هل تريد تصحيح أوقاتك؟ لا توجد مشكلة! باستخدام Clockin ، يمكنك بسهولة تصحيح وضبط الأوقات غير الصحيحة.",
        absences: "إدارة طلبات الإجازات والأيام المرضية والغياب الأخرى. تتبع دائما حالة طلباتك وأرسل طلبات جديدة بسهولة وسرعة ببضع نقرات فقط.",
        settings: "إرسال رسائل في الشركة أو تغيير إعداداتك الشخصية وإذا كنت ترغب في تغيير كلمة المرور الخاصة بك ، يمكنك القيام بذلك هنا!",
        thats_it: "المداره! يمكنك الآن إدارة وقتك دون عناء وتنظيم الغياب والتركيز على ما هو مهم: عملك. حظا سعيدا مع وقتك المنتج!"
      },
      button: {
        welcome: "أرني كيف يتم ذلك",
        thats_it: "ابدأ الآن"
      }
    },
    clock: {
      clockin_now: "أقفل الآن",
      clock_your_first_time_now: "وتسجيل المرة الأولى لك"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "شكراً لك على استخدام عقار على مدار الساعة!",
      question: "ما مدى احتمالية أن توصي أصدقائك أو زملائك باستخدام تطبيق \"هوكين\"؟",
      very_likely: "من المحتمل جدا",
      very_unlikely: "من المستبعد جدا",
      help_us_improve: "كيف يمكننا تحسين توقيت الساعة بالنسبة لك؟",
      what_do_you_agree_with: "ما هي العبارات التي تتفق معها؟",
      choose_three_statements: "اختر ما يصل إلى ثلاث عبارات.",
      hard_to_use: "صعوبة التشغيل",
      lacking_features: "وظائف قليلة جداً",
      does_not_help_me: "لا يجعل يوم عملي أسهل",
      confusing: "مربكة",
      poorly_implemented: "الوظائف المنفذة بشكل سيء",
      too_buggy: "عرضة للأخطاء",
      too_slow: "أوقات التحميل الطويلة",
      what_else: "هل هناك أي شيء آخر تودين إخبارنا به؟",
      can_we_ask_you_a_few_questions: "هل يمكننا أن نطرح عليك بعض الأسئلة الأخرى؟",
      how_happy_are_you_with_the_introduction_of_clockin: "ما مدى سعادتك بإدخال نظام \"ساعة في\" في شركتك؟",
      how_much_do_you_enjoy_using_clockin: "ما رأيك في استخدام عقارب الساعة؟",
      how_much_easier_does_clockin_make_your_work: "إلى أي مدى يجعل تسجيل الوقت في الساعة عملك اليومي أسهل؟",
      how_happy_are_you_with_the_following_aspects: "ما مدى رضاك عن النقاط التالية؟",
      clarity_of_the_app: "وضوح التطبيق",
      simplicity_of_use: "بساطة التشغيل",
      app_features: "الوظائف في التطبيق",
      feedback_received: "تم استلام ملاحظاتك. شكراً لك على وقتك.",
      thanks_for_taking_the_time: "شكراً لك على وقتك.",
      what_can_we_do_to_improve: "هل يمكنك إخبارنا بالمزيد عن تجربتك حتى نتمكن من القيام بعمل أفضل في المرة القادمة؟",
      what_can_we_do_to_get_it_right: "هل يمكنك إخبارنا بالمزيد عن تجربتك حتى نتمكن من الحصول عليها بشكل صحيح في المرة القادمة؟",
      comment_placeholder: "رسالتك"
    }
  },
  travel_logs: {
    add: "إضافة تفاصيل الرحلة",
    edit: "تحرير تفاصيل الرحلة",
    saving: "يتم حفظ تفاصيل الرحلة...",
    saved_successfully: "تم حفظ تفاصيل الرحلة بنجاح!",
    unable_to_save: "لسوء الحظ، لم ينجح ذلك 😢"
  },
  attach_file: "إرفاق ملف",
  image_to_text: {
    info: "تأكد من أن النص يمكن التعرف عليه بوضوح ويمكن رؤيته بالكامل على الصورة.",
    attach_image: "إرفاق صورة",
    processing: "سيتم قراءة النص الخاص بك في.",
    processing_failed: "لسوء الحظ، لم يعمل الاستيراد 😢",
    no_text_found: "لا يمكن التعرف على أي نص."
  },
  correction_enter_reason: "يرجى تقديم سبب التصحيح.",
  daily_notes: {
    add: "اكتب ملاحظة",
    edit: "تحرير ملاحظة",
    saving: "يتم حفظ الملاحظة...",
    saved_successfully: "تم حفظ الملاحظة بنجاح!",
    unable_to_save: "لسوء الحظ، لم ينجح ذلك 😢",
    no_notes_yet: "لم يتم إنشاء أي ملاحظة",
    create_note: "خلق"
  },
  calendar_sync: {
    title: "مزامنة الجدول الزمني",
    description: "يمكنك مزامنة جدول أعمالك مع التقويم ومراقبة المواعيد القديمة والجديدة.",
    url: "العنوان بتنسيق iCal",
    url_description: "يمكنك استخدام هذا العنوان للوصول إلى هذا التقويم من تطبيقات أخرى.",
    note: "تلميح",
    note_description: "مع بعض التقويمات، قد يستغرق عرض المواعيد الجديدة فيها مدة تصل إلى 24 ساعة.",
    sync_now: "مزامنة التقويم",
    copied: "تم نسخ رابط التقويم."
  },
  registration: {
    skip_all: "تخطي الكل",
    already_signed_up: "لدي حساب بالفعل",
    title_1: "لنبدأ! ما هي الأوقات التي ترغب في تسجيلها مع تسجيل الوقت؟",
    description_1: "دعنا نخصّص لك الساعة من أجلك",
    option_1_a: "وقت العمل العام (الذهاب والإياب والاستراحة)",
    option_1_b: "ساعات عمل المشروع",
    title_2: "هل ترغب في التوثيق؟",
    description_2: "ما هي المتطلبات التي يجب توافرها لهذا الغرض؟",
    option_2_a: "الصور",
    option_2_b: "رسومات تخطيطية",
    option_2_c: "وظيفة الملاحظة",
    option_2_d: "قوائم المراجعة والنماذج",
    option_2_e: "ملفات المشاريع الرقمية",
    title_3: "ما هي الأشياء الأخرى التي ترغب في رقمنتها؟",
    description_3: "هناك الكثير لاكتشافه في برنامج \"مدار الساعة\"، فربما يكون هناك ما يناسبك.",
    option_3_a: "عيد",
    option_3_b: "المرض والغياب",
    option_3_c: "ملف الموظفين الرقمي",
    option_3_d: "تحليل الشركة",
    option_3_e: "التخطيط التشغيلي",
    option_3_f: "مستشار ضرائب نقل البيانات (DATEV)",
    title_4: "في أي مجال تنشط شركتك؟",
    description_4: "نريد أن نتعرف عليك بشكل أفضل من أجل تخصيص الساعة أكثر لاحتياجاتك.",
    option_4_a: "الخدمات",
    option_4_b: "الحرف اليدوية",
    option_4_c: "الصحة والعافية",
    option_4_d: "الشراء والطلب والتداول",
    option_4_e: "الفنادق والمطاعم",
    option_4_f: "السيارات والنقل والآلات",
    option_4_g: "صناعات أخرى",
    title_5: "كم عدد الموظفين في شركتك؟",
    description_5: "من خلال عدد الموظفين، يمكننا تخصيص ساعات العمل حسب حجم شركتك.",
    title_6: "ممتاز! تم إعداد ساعتك الآن",
    description_6: "كل ما نحتاجه هو اسمك.",
    input_6_a: "شركة",
    input_6_b: "اللقب",
    input_6_c: "اللقب",
    input_6_d: "رقم الهاتف",
    title_7: "أنت جاهز للانطلاق! جرّب الساعة 14 يوماً مجاناً!",
    input_7_a: "عنوان بريدك الإلكتروني",
    description_7: "إلى أي عنوان بريد إلكتروني يجب أن نرسل كلمة المرور الخاصة بك؟",
    input_7_b: "هكذا أدركت",
    how_did_you_hear_about_clockin: "كيف سمعت لأول مرة عن برنامج \"مدار الساعة\"؟",
    recommendation_option_1: "التوصية",
    recommendation_option_2: "فيسبوك",
    recommendation_option_3: "انستقرام",
    recommendation_option_4: "البحث على الإنترنت",
    recommendation_option_5: "لينكد إن",
    recommendation_option_6: "منصة المقارنة",
    recommendation_option_7: "المجلات والمقالات على الإنترنت",
    known_from: "معروف من",
    agb_1: "بإرسال النموذج، فإنك توافق على ",
    agb_2: "حيث",
    agb_3: " و ",
    agb_4: "سياسة الخصوصية",
    start: "بدء الاختبار",
    validation_failed: "يرجى ملء جميع الحقول بشكل صحيح."
  },
  clocki: {
    listening_heading: "أنا أستمع إليك",
    listening_subtext: "هل يمكنني مساعدتك؟؟",
    hi_0: "مرحباً، كيف يمكنني مساعدتك؟",
    hi_1: "كيف يمكنني مساعدتك؟",
    hi_2: "مرحباً، كيف يمكنني مساعدتك؟",
    hi_3: "معين معين، ماذا يمكنني أن أفعل لك؟",
    hi_4: "مرحباً، كيف يمكنني مساعدتك؟",
    hi_5: "مرحباً، كيف يمكنني مساعدتك؟",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "لسوء الحظ، يبدو أن التعرف على الصوت لا يعمل على جهازك",
    microphone_permission_denied: "للأسف، لا يمكنني الوصول إلى الميكروفون الخاص بك. يرجى التحقق من التراخيص في الإعدادات حتى أتمكن من سماعك.",
    please_speak: "يمكنك الآن التحدث إلى Clocki",
    create_activity: "إنشاء نشاط",
    modify_activity: "تغيير النشاط",
    delete_activity: "حذف النشاط",
    create_daily_note: "إنشاء ملاحظة يومية",
    search_project: "البحث عن مشروع",
    note_copied: "تم نسخ الملاحظة",
    create_absence_request: "طلب الغياب",
    delete_absence: "حذف غياب",
    confirm_deletion: "هل أنت متأكد من أن {activity_label} الختم من {date} هل يجب حذف الساعة؟",
    confirm_absence_deletion: "هل أنت متأكد من أن طلبك ل {category} من {startDate} حتى {endDate} هل تريد الحذف؟",
    task_before_modification: "قبل: {task}",
    starts_at_before_modification: "وقت البدء قبل: {startsAt}",
    ends_at_before_modification: "وقت الانتهاء قبل: {endsAt}",
    something_went_wrong: "حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقاً.",
    was_this_helpful: "هل يمكن أن يساعدك Clocki؟",
    actions: {
      CREATE_ABSENCE: {
        title: "تأكيد الغياب"
      },
      CREATE_DAILY_NOTE: {
        title: "أنشئ ملاحظة الآن",
        daily_notes_disabled: "للأسف، وظيفة الملاحظات معطلة. يرجى مطالبة المسؤول بتفعيل الوظيفة في مركز المكتب.",
        success: "تم حفظ الملاحظة بنجاح في السجل اليومي 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "إنشاء الوثائق الآن",
        created_by_clocki: "تم إنشاؤها باستخدام Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "افتح \"أوقاتي\" الآن"
      },
      REDIRECT_TO_MY_AREA: {
        title: "افتح \"منطقتي\" الآن"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "افتح \"تغيير كلمة المرور\" الآن"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "ختم \"وقت العمل\" الآن",
        PAUSE: "ختم \"إيقاف مؤقت\" الآن",
        DRIVING_TIME: "ختم \"وقت الرحلة\" الآن",
        LOGOUT: "فتح القفل الآن"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "هل تحب استخدام Clockin؟"
  },
  translation_failed: "لسوء الحظ ، لم تنجح 😕 الترجمة",
  video_transcript_not_available: "لا يوجد نص متوفر",
  video_upload_succeeded: "تم تحميل الفيديو.",
  video_upload_failed: "فشل رفع الفيديو.",
  video_send_failed: "لم يكن بالإمكان بث الفيديو في الوقت الحالي. سنحاول مرة أخرى لاحقا.",
  uploading_video: "يتم رفع الفيديو...",
  language_selection_header: "لغة مختارة",
  language_selection_message: "اختر لغتك المفضلة",
  shifts: {
    my_shifts: "نوباتي",
    free_shifts: "الانتقالات الحرة",
    next_shift: "وردية عملك القادمة",
    shift_not_found: "لم يتم العثور على طبقات",
    show_shift_plan: "شاهد جدول الورديات هذا",
    no_shift_place: "لم يتم تحديد موقع",
    no_shifts_assigned: "أنت غير معين حاليا لأي وردية",
    free_shifts_unavailable: "الورديات الحرة غير متوفرة حاليا",
    filter_shift_plans: "جداول تبديل المرشحات",
    no_shift_plans_available: "لا توجد جداول وردية متاحة",
    filter_locations: "أماكن التصفية",
    no_locations_available: "لا توجد أماكن متاحة",
    no_plan_selected: "لم يتم اختيار جدول ورديات",
    no_shifts_for_plan: "لم يتم العثور على طبقات لهذه الخطة",
    no_shifts_for_location: "لم يتم العثور على أي تغييرات في الموقع المحدد",
    unknown_shift_plan: "جدول الورديات غير المعروف",
    unknown_location: "الموقع غير معروف",
    loading_more_shifts: "حمل المزيد من الطبقات..."
  },
  clockin_reminder_title: "هل أنت بالفعل في العمل؟ 🔔",
  clockin_reminder: "تذكر تسجيل الدخول.",
  clockout_reminder_title: "هل أنت بالفعل في نهاية اليوم؟ 🔔",
  clockout_reminder: "لا تنس تسجيل الخروج.",
  choose_clockin_reminder_time: "وقت تذكير تسجيل الدخول",
  choose_clockout_reminder_time: "وقت تذكير انتهاء الساعات",
  choose_break_reminder_time: "طول التوقف",
  saved_successfully: "تم إنقاذه 👍 بنجاح",
  clock_reminder_channel_name: "تذكيرات بالطوابع",
  clock_reminder_channel_description: "تذكيرات بتسجيل الدخول والخروج",
  break_reminder_title: "هل ما زلت تأخذ استراحة؟ ⏰",
  break_reminder: "ملاحظة: وقت استراحتك لا يزال مستمرا.",
  // Video component translations
  video_not_supported: "جهازك لا يدعم الفيديو :/",
  video_loading_error: "خطأ في تحميل الفيديو",
  video_retry: "إعادة التعبئة"
};